import React from 'react';

import { BigText, ContainerSection, ContentSection, NormalText } from './style';

function Section({ img, text1, bigText, text2 }) {
  return (
    <ContainerSection>
      <img src={img} alt="imagem " />
      <ContentSection>
        <NormalText>{text1}</NormalText>
        <BigText>{bigText}</BigText>
        <NormalText>{text2}</NormalText>
      </ContentSection>
    </ContainerSection>
  );
}

export default Section;
